import React from 'react';
import { Bot, User, Loader2, Search } from 'lucide-react';
import clsx from 'clsx';

const ChatMessage = ({ message, isLoading }) => {
  const isUser = message.role === 'user';
  const isAssistant = message.role === 'assistant';
  const isSearchNotification = message.isSearchNotification;

  if (isLoading && isAssistant) {
    return (
      <div className="flex items-start space-x-3 animate-pulse">
        <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center flex-shrink-0">
          <Bot className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 bg-white border border-gray-200 rounded-lg p-4">
          <div className="flex items-center space-x-2">
            <Loader2 className="w-4 h-4 animate-spin text-gray-400" />
            <span className="text-gray-500">LENA is thinking...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={clsx(
      "flex items-start space-x-3",
      isUser ? "flex-row-reverse space-x-reverse" : ""
    )}>
      <div className={clsx(
        "w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0",
        isUser ? "bg-primary-600" : isSearchNotification ? "bg-blue-500" : "bg-gray-200"
      )}>
        {isUser ? (
          <User className="w-5 h-5 text-white" />
        ) : isSearchNotification ? (
          <Search className="w-5 h-5 text-white" />
        ) : (
          <Bot className="w-5 h-5 text-gray-600" />
        )}
      </div>
      
      <div className={clsx(
        "flex-1 rounded-lg p-4 max-w-3xl",
        isUser 
          ? "bg-primary-600 text-white" 
          : isSearchNotification
            ? "bg-blue-50 border border-blue-200 shadow-sm"
            : "bg-white border border-gray-200 shadow-sm"
      )}>
        <div className="prose prose-sm max-w-none">
          {isUser ? (
            <p className="text-white">{message.content}</p>
          ) : isSearchNotification ? (
            <div className="text-blue-700 font-medium">
              {message.content}
            </div>
          ) : (
            <div className="text-gray-900">
              {message.content.split('\n').map((line, index) => (
                <p key={index} className="mb-2 last:mb-0">
                  {line}
                </p>
              ))}
            </div>
          )}
        </div>
        
        {message.timestamp && (
          <div className={clsx(
            "text-xs mt-2",
            isUser ? "text-primary-100" : "text-gray-500"
          )}>
            {new Date(message.timestamp).toLocaleTimeString()}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
